import { useState, useContext, FormEvent } from "react";
import Input from './form/Input';
import { useNavigate, useOutletContext } from "react-router-dom";
import { appContext, alertTypes } from '../App';
import config from '../config';

interface RegistrationPayload {
    first_name: string;
    last_name: string;
    email: string;
    password: string;
    confirm_password: string;
}

const RegistrationPage: React.FC = () => {
    const [first_name, setFirstName] = useState<string>("");
    const [last_name, setLastName] = useState<string>(""); 
    const [email, setEmail] = useState<string>("");
    const [password, setPassword] = useState<string>("");
    const [confirm_password, setConfirmPassword] = useState<string>("");

    const appCtx = useContext(appContext);
    if (!appCtx) {
        throw new Error("appContext is undefined");
    }
    const { toggleAlert, changeAlertType, changeUserID } = appCtx;
    const { setJwtToken, setIsAdmin, setAlertTitle, setAlertMessage, toggleRefresh } = useOutletContext<any>();

    const navigate = useNavigate();

    const handleSubmit = (event: FormEvent) => {
        event.preventDefault();

        // build the request payload
        const payload: RegistrationPayload = {
            first_name,
            last_name,
            email,
            password,
            confirm_password,
        };

        const requestOptions: RequestInit = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            credentials: 'include',
            body: JSON.stringify(payload),
        };

        console.log(`${config.backendUrl}/api/register`);

        fetch(`${config.backendUrl}/api/register`, requestOptions)
            .then((response) => response.json())
            .then((data) => {
                if (data.error) {
                    changeAlertType(alertTypes.Warning);
                    setAlertTitle("Warning");
                    setAlertMessage(data.message);
                } else {
                    setJwtToken(data.access_token);
                    setIsAdmin(data.is_admin); 
                    changeUserID(data.user_id);
                    changeAlertType(alertTypes.Success);
                    setAlertTitle("Uspješno ste registrirali vaš novi korisnički račun.");
                    toggleRefresh(true);
                    navigate('/');
                }
                toggleAlert(true);
            })
            .catch(err => {
                changeAlertType(alertTypes.Danger);
                setAlertTitle("Greška");
                setAlertMessage(err.message);
                toggleAlert(true);
                console.log(err);
            });
    };

    return (
        <>
            <div className="col-md-6 offset-md-3">
                <br/>
                <h2>Registriraj se</h2>
                <hr/>

                <form onSubmit={handleSubmit}>
                    <Input 
                        title="Ime"
                        type="text"
                        className="form-control"
                        name="first-name"
                        autoComplete="first-name-new"
                        onChange={(event) => setFirstName(event.target.value)}
                   />
                   <Input 
                        title="Prezime"
                        type="text"
                        className="form-control"
                        name="last-name"
                        autoComplete="last-name-new"
                        onChange={(event) => setLastName(event.target.value)}
                   />
                   <Input 
                        title="Email adresa"
                        type="email"
                        className="form-control"
                        name="email"
                        autoComplete="email-new"
                        onChange={(event) => setEmail(event.target.value)}
                   />
                   <Input 
                        title="Lozinka"
                        type="password"
                        className="form-control"
                        name="password"
                        autoComplete="password-new"
                        onChange={(event) => setPassword(event.target.value)}
                   />
                   <Input 
                        title="Ponovi lozinku"
                        type="password"
                        className="form-control"
                        name="password-confirm"
                        autoComplete="password-confirm-new"
                        onChange={(event) => setConfirmPassword(event.target.value)}
                   />

                   <hr/>

                   <input 
                        type="submit"
                        className="btn btn-primary"
                        value="Registriraj se"
                    />
                </form>
                <br/>
                <br/>
            </div>
        </>
    );
}

export default RegistrationPage;
